document.addEventListener('alpine:init', () => {
    Alpine.data('cartDrawer', () => ({
        isActive: false,
        currentItemKey: null,
        errorMessage: [],
        initialized: false,
        init() {
            this.addEventListeners();
            this.referAFriendCode()
        },
        async changeItemQuantity(lineItem, quantity, replaceItem) {
            this.currentItemKey = lineItem
            // Make a fetch request to remove the item from the cart
            await fetch(`/cart/change.js?id=${lineItem}&quantity=${quantity}`, {
                method: 'POST', // Use POST method for removing items
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
            })
                .then(response => response.json())
                .then(cartData => {
                    if (cartData.status == 422) {
                        this.errorMessage[lineItem] = cartData.message
                    } else {
                        this.errorMessage = []
                        if (replaceItem != true) {
                            this.$dispatch('product:added')
                        } else {
                            this.$dispatch('product:removed')
                        }
                    }
                })
                .catch(error => {
                    console.error('Error removing item from the cart:', error);
                });
        },

        addEventListeners() {
            window.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' && this.isActive) {
                    this.closeDrawer();
                }
            });

            document.addEventListener('cartDrawer:open', () => {
                this.openDrawer();
            });

            document.addEventListener('cartDrawer:close', () => {
                this.closeDrawer();
            });

            document.addEventListener('htmx:afterRequest', () => {
                this.currentItemKey = null
                this.referAFriendCode()
            });
        },
        formatPrice(price) {
            return Shopify.formatMoney(price, window.shopMoneyFormat)
        },
        openDrawer() {
            this.isActive = true;
            document.querySelector('html').classList.add('overflow-hidden');
        },
        closeDrawer() {
            this.isActive = false;
            document.querySelector('html').classList.remove('overflow-hidden');
        },
        referAFriendCode() {
            // Enter your Mention Me partner code here:
            var partnerCode = 'mm7580e65e';

            var situation = 'sidecart';
            var implementation = 'link';
            // This will ensure the implementation (link) and situation (sidecart) get
            // cleared before loading the Mention Me tag shown on refresh or page change.
            if (window.MentionMeFiredTags != undefined && window.MentionMeFiredTags != '') {
                if (window.MentionMeFiredTags[implementation + situation] == true) {
                    delete window.MentionMeFiredTags[implementation + situation];
                }
            }

            var urlComponents = ['https://tag.mention-me.com/api/v2/refereefind/', partnerCode];

            var queryComponents = [
                ['situation', situation],
                // Locale
                ['locale', Shopify.locale + '_' + Shopify.country],
            ];

            queryComponents = queryComponents.map((qc) => qc[0] + '=' + encodeURIComponent(qc[1]));

            var url = urlComponents.join('') + '?' + queryComponents.join('&');

            var script = document.createElement('script');
            script.src = url;

            document.getElementsByTagName('head')[0].appendChild(script);
        }
    }
    ))
})
